import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./BeLaunchified.css";
const BeLaunchifiedCard = ({ title, description, link, duration, status }) => {
  const handleClick = () => {
    window.open(link, "_blank");
  };

  const imageMap = {
    launch: "./assets/images/lCourse.png",
    teradata: "./assets/images/Teradata.png",
    azure: "./assets/images/microsoftAzure.png",
    abinitio: "./assets/images/abinitio.png",
    cognos: "./assets/images/Cognos.png",
    tableau: "./assets/images/Tableau.png",
    "power bi": "./assets/images/MicrosoftBI.png",
    bi: "./assets/images/business.png",
  };

  const getCourseImage = (title) => {
    title = title.toLowerCase();
    for (const keyword in imageMap) {
      if (title.includes(keyword)) {
        return imageMap[keyword];
      }
    }
    return "./assets/images/BI.png";
  };

  return (
    <Container className={`card ${title === "LAUNCH" ? "launch-card" : ""}`}>
      <div>
        <Row>
          <Col>
            <img
              src={getCourseImage(title)}
              className="card-img"
              alt="imgurl"
            />
            {title.toLowerCase().includes("launch") && (
              <div className="mandatory-star"></div>
            )}
          </Col>
          <Col md={{ span: 8 }}>
            <h3
              className={`mb-4 launchtitle ${title === "LAUNCH" ? "launch-title" : "gen-AI-101-certification"}`}
            >
              {title}
            </h3>
            <h5 className="mb-4 knowledge-check-gen-AI">{description}</h5>
          </Col>
        </Row>
        <Row className="p-1 g-col-1 border-top">
          <Col>
            <div className="intended-audience-everyone">
              Intended Audience
              <div className="text-style-1">Everyone</div>
            </div>
          </Col>
          {duration && duration.trim() !== "" && (
            <Col>
              <div className="duration-150-minutes">
                <div className="text-style-1">Duration</div>
                {duration}
              </div>
            </Col>
          )}
          <Col>
            <Col>
              <button
                type="button"
                className="enroll btn btn-dark"
                onClick={handleClick}
              >
                {status && status.trim() !== "" ? status : "Enroll me"}
              </button>
            </Col>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default BeLaunchifiedCard;
